import type { GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { Formatter } from "utils";
import { TAG_TREES } from "utils/constants";
import { is404 } from "utils/newFunction";
import { slugMaker } from "utils/normalizer";
import { EventDetails } from "views";

function EventDetailsPage({ data }) {
  return <EventDetails data={data} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  locale,
}) => {
  const apiService = new ApiService(locale);
  try {
    const entityId = params?.slug?.[0];
    const slug = params?.slug?.[1];
    const requests = [];

    if (Number.isNaN(+entityId)) {
      return {
        notFound: true,
      };
    }

    requests.push(apiService.getEventById(entityId, { formatter: false })); // 0
    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}

    if (is404(response?.[0])) {
      return {
        notFound: true,
      };
    }

    const target = Formatter.formatData({ data: response?.[0] })?.[0] || null;

    // index only news that have same language
    if (
      !target?.tagTrees?.find((item) =>
        [
          TAG_TREES[locale?.toUpperCase() || "FA"]?.EVENTS,
          TAG_TREES[locale?.toUpperCase() || "FA"]?.GRADUATED_EVENTS,
        ].includes(item?.name)
      )
    ) {
      return {
        notFound: true,
      };
    }

    const normalizedSlug =
      target?.metaTag?.slug || slugMaker(target?.title?.value);
    if (normalizedSlug && normalizedSlug !== slug) {
      return {
        redirect: {
          permanent: true,
          destination: `${
            locale === "en" ? "/en" : ""
          }/declarations/${entityId}/${encodeURIComponent(normalizedSlug)}`,
        },
      };
    }
    return {
      props: {
        data: {
          event: target,
          changeLanguageLink: target?.changeLanguageLink?.value || "",
          canonical: !target?.changeLanguageLink?.value,
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default EventDetailsPage;
